module.exports = __webpack_public_path__ + "static/media/eco-ecology-fish-svgrepo-com.3057d00c.svg";